export enum AssignedItemsActionsEnum {
  CREATE = 'create',
  UPDATE = 'update',
}
